export const utc = 'UTC';
export const pacificAuckland = 'Pacific/Auckland';
export const pacificChatham = 'Pacific/Chatham';
